import React, { Component } from "react";
import MPSSelect from "../../../components/MPSSelect";

class SurveySelectDropDown extends Component {
  render() {
    let { surveys, surveyId, loading } = this.props;

    return (
      <div className="row">
        <div className="col-12 col-sm-12">
          <MPSSelect
            value={surveyId}
            onChange={(option) => {
              this.props.save(option ? option.survey : null);
            }}
            options={surveys.map((item, index) => {
              return {
                value: item.id,
                label: item.title,
                survey: item,
              };
            })}
            isLoading={loading}
          />
        </div>
      </div>
    );
  }
}

export default SurveySelectDropDown;
